import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { useDict } from '../../../contexts/LanguageContext';
import ROUTE_NAME from '../../../routes/RouteName';
import FaqContainer from './FaqContainer';

const RiskManagement = () => {
    const dict = useDict();

    return (
        <FaqContainer
            navigationActive="riskmanagement"
            prevLink={ROUTE_NAME.FAQ_INVESTMENT_MEMOS}
            prevTitle={dict.investmentMemos}
            nextLink={ROUTE_NAME.FAQ_FEES_AND_CHARGES}
            nextTitle={dict.feesAndCharges}
        >
            <Card className="card--not-full-height">
                <CardBody className="documentation__card-body">
                    <div className="card__title">
                        <h3 className="bold-text" style={{ color: '#264391' }}>
                            {dict.riskManagement}
                        </h3>
                    </div>
                    <p>
                        <strong>
                            {dict.riskManagementTitle1}
                        </strong>
                    </p>
                    <p>
                        {dict.riskManagementTitle1Text1}
                    </p>
                    <ul>
                        <li>{dict.riskManagementTitle1Text1List1}</li>
                        <li>{dict.riskManagementTitle1Text1List2}</li>
                        <li>{dict.riskManagementTitle1Text1List3}</li>
                        <li>{dict.riskManagementTitle1Text1List4}</li>
                        <li>{dict.riskManagementTitle1Text1List5}</li>
                        <li>
                            {dict.riskManagementTitle1Text1List6}
                            <ul>
                                <li>{dict.riskManagementTitle1Text1List6Sublist1}</li>
                            </ul>
                        </li>
                        <li>{dict.riskManagementTitle1Text1List7}</li>
                    </ul>
                    <p>
                        <strong>
                            {dict.riskManagementTitle2}
                        </strong>
                    </p>
                    <p>
                        {dict.riskManagementTitle2Text1}
                    </p>
                    <p>
                        <strong>
                            {dict.riskManagementTitle3}
                        </strong>
                    </p>
                    <p>
                        {dict.riskManagementTitle3Text1}
                    </p>
                    <p>
                        {dict.riskManagementTitle3Text2}
                    </p>
                    <p>
                        {dict.riskManagementTitle3Text3}
                    </p>
                    <p>
                        <strong>
                            {dict.riskManagementTitle4}
                        </strong>
                    </p>
                    <p>
                        {dict.riskManagementTitle4Text1}
                    </p>
                </CardBody>
            </Card>
        </FaqContainer>
    );
};

export default RiskManagement;
